<template>
    <div>


        <v-row class="mb-12">
            <v-app-bar color="white " height="120" flat fixed class="pl-5  pr-5  ">

                <v-app-bar-nav-icon class="hidden-sm-and-down" v-if="IsDash" @click="drawer = true"></v-app-bar-nav-icon>


                <v-toolbar-title class=" ml-5" color="orange">
                    <v-img class=" mt-1" width="80" src="../assets/ayoola-full-t.png" />
                </v-toolbar-title>

                <v-spacer></v-spacer>



                <v-spacer></v-spacer>
                <v-btn v-if="IsDash" to="/">Home</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="IsDash" to="/about">About</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="IsDash" to="/work">How it Works</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="IsDash" to="/contact">Contact</v-btn>


                <v-btn large to="/dashboard" class="mt-2 blue darken-1 mr-12 white--text text-capitalize" v-if="anony && !IsDash">Dashboard</v-btn>

                <v-btn large class="mt-2 blue darken-1 mr-12 white--text text-capitalize" v-if="!anony && !IsDash" to="/account/signin">Get Started</v-btn>

                <!--<v-badge bordered v-if="anony"
                         color="red"
                         content="4"
                         offset-x="25"
                         offset-y="20">
                    <v-btn icon x-large
                           color="blue">
                        <v-icon>mdi-bell</v-icon>

                    </v-btn>
                </v-badge>-->

                <v-spacer v-if="anony"></v-spacer>
                <!--<v-avatar v-if="anony" class="mr-8" size="60" to="/account" @click.native="$router.go()">


                    <v-img :src="this.profile.displayPicture" lazy-src="https://i.pravatar.cc/200?img=7" />
                </v-avatar>-->





            </v-app-bar>
        
        </v-row>

    </div>
</template>

<script>
    //import { mapGetters, mapActions } from "vuex";

   // import { TokenService } from '@/services/storage.service';

    export default {
        data: () => ({
            drawer: true,
            group: null,
            tests: [],
            selectedTest: null,
            anony: false,
            IsDash: false,

        }),
        props: {



           






        },
        methods: {
            async load() {
                //await this.getProfile();


             
            },
            loggedoff() {
                // console.log("sssss");
               // this.logout();
            },

            //...mapActions('auth', [
            //    'getProfile', 'logout'

            //]),



        },
        computed: {

            //...mapGetters('auth', [
            //    'profile',

            //]),
            //modPicture() {
            //    return ""
            //    if (this.profile != null) {
            //        return this.profile.displayPicture;
            //    }
            //    else {
            //        return "";
            //    }
            //}


        },
        beforeMount() {

           // TokenService.getRoles();

            //this.load();
           // this.anony = TokenService.getToken();
           
        },
        mounted() {
            //console.log(this.profile);
        }
    }
</script>

<style scoped>
</style>